module.exports = __webpack_public_path__ + "img/sf.a864bad1.png";